import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const atBottom =
        window.innerHeight + y >= document.documentElement.scrollHeight - 80;
      setVisible(y > 600 && !atBottom);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const label = "Retour en haut";

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={label}
      data-testid="back-to-top"
      className={`group fixed bottom-5 right-4 sm:bottom-8 sm:right-6 lg:bottom-10 lg:right-8 z-[10000] inline-flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#181A1D] text-[#FAF9F7] border border-[#181A1D] shadow-md transition-[opacity,transform] duration-300 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-3 pointer-events-none"
      } hover:bg-[#E94B3C] hover:border-[#E94B3C]`}
    >
      <ArrowUp size={18} strokeWidth={1.5} className="transition-transform duration-500 group-hover:-translate-y-0.5" />
      <span className="sr-only">{label}</span>
    </button>
  );
}
